export const TRANSFER_TYPES: TransferType[] = [
  'airport',
  'skiStation',
  'coast',
  'puntaCana',
]
